module.exports = __webpack_public_path__ + "img/media-nga@2x.231f4e52.png";